import { api } from './api';
import type { RespostaSucesso } from '@/tipos';
import type { PapelPainel, Tutelado, Desempenho, PlanoDisciplina } from '@/tipos/painel.tipos';

export const painelServico = {
  async whoami(): Promise<PapelPainel> {
    const r = await api.get<RespostaSucesso<{ papel: PapelPainel }>>('/painel/whoami');
    return r.data.data.papel;
  },
  async alunoResumo() {
    const r = await api.get<RespostaSucesso<unknown>>('/painel/aluno/resumo');
    return r.data.data;
  },
  async alunoNotas() {
    const r = await api.get<RespostaSucesso<unknown[]>>('/painel/aluno/notas');
    return r.data.data;
  },
  async alunoFrequencia() {
    const r = await api.get<RespostaSucesso<unknown>>('/painel/aluno/frequencia');
    return r.data.data;
  },
  async alunoHorario() {
    const r = await api.get<RespostaSucesso<{ dados: unknown[] }>>('/painel/aluno/horario');
    return r.data.data;
  },
  async tutelados(): Promise<Tutelado[]> {
    const r = await api.get<RespostaSucesso<Tutelado[]>>('/painel/responsavel/tutelados');
    return r.data.data;
  },
  async tuteladoResumo(id: string) {
    const r = await api.get<RespostaSucesso<unknown>>(`/painel/responsavel/tutelados/${id}/resumo`);
    return r.data.data;
  },
  async tuteladoNotas(id: string) {
    const r = await api.get<RespostaSucesso<unknown[]>>(`/painel/responsavel/tutelados/${id}/notas`);
    return r.data.data;
  },
  async tuteladoFrequencia(id: string) {
    const r = await api.get<RespostaSucesso<unknown>>(`/painel/responsavel/tutelados/${id}/frequencia`);
    return r.data.data;
  },
  async tuteladoHorario(id: string) {
    const r = await api.get<RespostaSucesso<{ dados: unknown[] }>>(`/painel/responsavel/tutelados/${id}/horario`);
    return r.data.data;
  },
  async alunoDesempenho() {
    const r = await api.get<RespostaSucesso<Desempenho>>('/painel/aluno/desempenho');
    return r.data.data;
  },
  async alunoPlano(turmaDisciplinaId: string) {
    const r = await api.get<RespostaSucesso<PlanoDisciplina[]>>(`/painel/aluno/disciplinas/${turmaDisciplinaId}/plano`);
    return r.data.data;
  },
  async tuteladoDesempenho(id: string) {
    const r = await api.get<RespostaSucesso<Desempenho>>(`/painel/responsavel/tutelados/${id}/desempenho`);
    return r.data.data;
  },
  async tuteladoPlano(id: string, turmaDisciplinaId: string) {
    const r = await api.get<RespostaSucesso<PlanoDisciplina[]>>(`/painel/responsavel/tutelados/${id}/disciplinas/${turmaDisciplinaId}/plano`);
    return r.data.data;
  },
};
